import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Add to an existing repository",
  "description": "Using Turborepo with your existing repository"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo can be incrementally adopted in any repository, single or multi-package, to speed up the developer and CI workflows of the repository."
  }, {
    "heading": "",
    "content": "After installing turbo and configuring your tasks in turbo.json, you'll notice how caching helps you run tasks much faster."
  }, {
    "heading": "preparing-a-single-package-workspace",
    "content": "A single-package workspace is, for example, what you get after running npx create-next-app or npm create vite. You don't need to do any extra work for Turborepo to handle your repo so you can jump to the first step below."
  }, {
    "heading": "preparing-a-single-package-workspace",
    "content": "To learn more about Turborepo in single-package workspaces, visit the dedicated guide."
  }, {
    "heading": "preparing-a-multi-package-workspace-monorepo",
    "content": "turbo is built on top of Workspaces, a feature of the major package managers in the JavaScript ecosystem. This makes it easy to adopt in your existing codebase."
  }, {
    "heading": "preparing-a-multi-package-workspace-monorepo",
    "content": "If you're finding that turbo is having issues like not being able to\ndiscover packages in your workspace or not following your dependency graph,\nvisit our Structuring a\nrepository page for\ntips."
  }, {
    "heading": "preparing-a-multi-package-workspace-monorepo",
    "content": "Note that you don't have to start running all your tasks for all your\npackages using turbo right away. You can start with a single task in just a\nfew packages and incrementally add more tasks and packages as you get more\nfamiliar with Turborepo."
  }, {
    "heading": "install-turbo",
    "content": "We recommend you install turbo both globally and into your repository's root for the best developer experience."
  }, {
    "heading": "install-turbo",
    "content": "Ensure you have created a pnpm-workspace.yaml file before you begin the installation. Failure to have this file will result in an error that says:  --workspace-root may only be used inside a workspace."
  }, {
    "heading": "install-turbo",
    "content": "To learn more about why we recommend both installations, visit the Installation page."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "In the root of your repository, create a turbo.json file."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "We'll be using build and check-types tasks in this guide but you can replace these with other tasks that interest you, like lint or test."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "For more information on configuring your turbo.json, see the Configuration Options documentation."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "In your Next.js application, make sure you have a check-types script for turbo to run."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "Some Vite starters ship with a package.json that looks like this:"
  }, {
    "heading": "add-a-turbojson-file",
    "content": "We recommend splitting these into a check-types and build script so that turbo can run them in parallel."
  }, {
    "heading": "add-a-turbojson-file",
    "content": "In a multi-package workspace, you may also want to add a check-types script\nto one or more of your library packages to see how multiple scripts across\ndifferent packages run with one turbo command."
  }, {
    "heading": "edit-gitignore",
    "content": "Add .turbo to your .gitignore file. The turbo CLI uses these folders for persisting logs, outputs, and other functionality."
  }, {
    "heading": "add-a-packagemanager-field-to-root-packagejson",
    "content": "Turborepo optimizes your repository using information from your package manager. To declare which package manager you're using, add a packageManager field to your root package.json if you don't have one already."
  }, {
    "heading": "add-a-packagemanager-field-to-root-packagejson",
    "content": "Depending on your repository, you may need to use the\ndangerouslyDisablePackageManagerCheck\nwhile migrating or in situations where you can't use the packageManager key\nyet."
  }, {
    "heading": "set-up-package-manager-workspaces",
    "content": "For multi-package workspaces, you'll need to configure your package manager to recognize your workspace structure."
  }, {
    "heading": "set-up-package-manager-workspaces",
    "content": "The workspaces field tells your package manager which directories contain your packages. Common patterns include apps/* for applications and packages/* for shared libraries."
  }, {
    "heading": "set-up-package-manager-workspaces",
    "content": "If you're working with a single-package repository, you can skip this step as\nworkspaces aren't needed."
  }, {
    "heading": "set-up-package-manager-workspaces",
    "content": "For more details on how to structure your repository, see Structuring a Repository."
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "You can now run the tasks you added to turbo.json earlier using Turborepo. Using the example tasks from above:"
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "This runs the build and check-types tasks at the same time. The dependency graph of your Workspace will be used to run tasks in the right order."
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "Without making any changes to the code, try running build and check-types again:"
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "You should see terminal output like this:"
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "Congratulations! You just built and type checked your code in milliseconds."
  }, {
    "heading": "run-tasks-with-turbo",
    "content": "To learn more about how turbo makes this possible, check out the caching documentation."
  }, {
    "heading": "begin-developing-by-running-dev-with-turbo",
    "content": "In a multi-package workspace, you can run turbo dev to start the development tasks for all your packages at once."
  }, {
    "heading": "begin-developing-by-running-dev-with-turbo",
    "content": "You can also use a filter to focus on a specific package and its dependencies."
  }, {
    "heading": "begin-developing-by-running-dev-with-turbo",
    "content": "Note that this step doesn't provide much value in a single-package workspace since:"
  }, {
    "heading": "begin-developing-by-running-dev-with-turbo",
    "content": "You don't cache the outputs for a development task."
  }, {
    "heading": "begin-developing-by-running-dev-with-turbo",
    "content": "There's only one development script so there's nothing to run in parallel."
  }, {
    "heading": "next-steps",
    "content": "You're now up and running with Turborepo! To learn about more ways you can improve your workflow and get the most out of turbo, we recommend checking out the following pages:"
  }, {
    "heading": "next-steps",
    "content": "Enabling Remote Caching for development machines"
  }, {
    "heading": "next-steps",
    "content": "Enabling Remote Caching in CI"
  }, {
    "heading": "next-steps",
    "content": "Handling environment variables"
  }, {
    "heading": "next-steps",
    "content": "Filtering tasks"
  }],
  "headings": [{
    "id": "preparing-a-single-package-workspace",
    "content": "Preparing a single-package workspace"
  }, {
    "id": "preparing-a-multi-package-workspace-monorepo",
    "content": "Preparing a multi-package workspace (monorepo)"
  }, {
    "id": "adding-turborepo-to-your-repository",
    "content": "Adding Turborepo to your repository"
  }, {
    "id": "install-turbo",
    "content": "Install turbo"
  }, {
    "id": "add-a-turbojson-file",
    "content": "Add a turbo.json file"
  }, {
    "id": "edit-gitignore",
    "content": "Edit .gitignore"
  }, {
    "id": "add-a-packagemanager-field-to-root-packagejson",
    "content": "Add a packageManager field to root package.json"
  }, {
    "id": "set-up-package-manager-workspaces",
    "content": "Set up package manager workspaces"
  }, {
    "id": "run-tasks-with-turbo",
    "content": "Run tasks with turbo"
  }, {
    "id": "begin-developing-by-running-dev-with-turbo",
    "content": "Begin developing by running dev with turbo"
  }, {
    "id": "next-steps",
    "content": "Next steps"
  }]
};
import {PackageManagerTabs, Tabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {Step, Steps} from '#components/steps';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#preparing-a-single-package-workspace",
  title: _jsx(_Fragment, {
    children: "Preparing a single-package workspace"
  })
}, {
  depth: 2,
  url: "#preparing-a-multi-package-workspace-monorepo",
  title: _jsx(_Fragment, {
    children: "Preparing a multi-package workspace (monorepo)"
  })
}, {
  depth: 2,
  url: "#adding-turborepo-to-your-repository",
  title: _jsx(_Fragment, {
    children: "Adding Turborepo to your repository"
  })
}, {
  depth: 3,
  url: "#install-turbo",
  title: _jsxs(_Fragment, {
    children: ["Install ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 3,
  url: "#add-a-turbojson-file",
  title: _jsxs(_Fragment, {
    children: ["Add a ", _jsx("code", {
      children: "turbo.json"
    }), " file"]
  })
}, {
  depth: 3,
  url: "#edit-gitignore",
  title: _jsxs(_Fragment, {
    children: ["Edit ", _jsx("code", {
      children: ".gitignore"
    })]
  })
}, {
  depth: 3,
  url: "#add-a-packagemanager-field-to-root-packagejson",
  title: _jsxs(_Fragment, {
    children: ["Add a ", _jsx("code", {
      children: "packageManager"
    }), " field to root ", _jsx("code", {
      children: "package.json"
    })]
  })
}, {
  depth: 3,
  url: "#set-up-package-manager-workspaces",
  title: _jsx(_Fragment, {
    children: "Set up package manager workspaces"
  })
}, {
  depth: 3,
  url: "#run-tasks-with-turbo",
  title: _jsxs(_Fragment, {
    children: ["Run tasks with ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 3,
  url: "#begin-developing-by-running-dev-with-turbo",
  title: _jsxs(_Fragment, {
    children: ["Begin developing by running ", _jsx("code", {
      children: "dev"
    }), " with ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 2,
  url: "#next-steps",
  title: _jsx(_Fragment, {
    children: "Next steps"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo can be incrementally adopted in ", _jsx(_components.strong, {
        children: "any repository, single or multi-package"
      }), ", to speed up the developer and CI workflows of the repository."]
    }), "\n", _jsxs(_components.p, {
      children: ["After installing ", _jsx(_components.code, {
        children: "turbo"
      }), " and configuring your tasks in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", you'll notice how ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " helps you run tasks much faster."]
    }), "\n", _jsx(_components.h2, {
      id: "preparing-a-single-package-workspace",
      children: "Preparing a single-package workspace"
    }), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#single-package-workspace",
        children: "single-package workspace"
      }), " is, for example, what you get after running ", _jsx(_components.code, {
        children: "npx create-next-app"
      }), " or ", _jsx(_components.code, {
        children: "npm create vite"
      }), ". You don't need to do any extra work for Turborepo to handle your repo so you can jump to the first step below."]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about Turborepo in single-package workspaces, visit ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "the dedicated guide"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "preparing-a-multi-package-workspace-monorepo",
      children: "Preparing a multi-package workspace (monorepo)"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " is built on top of Workspaces, a feature of the major package managers in the JavaScript ecosystem. This makes it easy to adopt in your existing codebase."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["If you're finding that ", _jsx(_components.code, {
          children: "turbo"
        }), " is having issues like not being able to\ndiscover packages in your workspace or not following your dependency graph,\nvisit our ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/structuring-a-repository",
          children: "Structuring a\nrepository"
        }), " page for\ntips."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Note that you don't have to start running ", _jsx(_components.em, {
        children: "all"
      }), " your tasks for ", _jsx(_components.em, {
        children: "all"
      }), " your\npackages using ", _jsx(_components.code, {
        children: "turbo"
      }), " right away. You can start with a single task in just a\nfew packages and incrementally add more tasks and packages as you get more\nfamiliar with Turborepo."]
    }), "\n", _jsx(_components.h2, {
      id: "adding-turborepo-to-your-repository",
      children: "Adding Turborepo to your repository"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "install-turbo",
          children: ["Install ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["We recommend you install ", _jsx(_components.code, {
            children: "turbo"
          }), " both globally and into your repository's root for the best developer experience."]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsxs(_components.p, {
              children: ["Ensure you have created a ", _jsx(_components.code, {
                children: "pnpm-workspace.yaml"
              }), " file before you begin the installation. Failure to have this file will result in an error that says: ", _jsx(_components.code, {
                children: " --workspace-root may only be used inside a workspace"
              }), "."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "pnpm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --workspace-root"
                    })]
                  })]
                })
              })
            })]
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " global"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "yarn"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "npm"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --save-dev"
                    })]
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "Terminal",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Global install"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --global"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-comment)",
                        "--shiki-dark": "var(--shiki-token-comment)"
                      },
                      children: "# Install in repository"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: "bun"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " install"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " turbo"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string)",
                        "--shiki-dark": "var(--shiki-token-string)"
                      },
                      children: " --dev"
                    })]
                  })]
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["To learn more about why we recommend both installations, visit the ", _jsx(_components.a, {
            href: "/docs/getting-started/installation",
            children: "Installation page"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "add-a-turbojson-file",
          children: ["Add a ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file"]
        }), _jsxs(_components.p, {
          children: ["In the root of your repository, create a ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file."]
        }), _jsxs(_components.p, {
          children: ["We'll be using ", _jsx(_components.code, {
            children: "build"
          }), " and ", _jsx(_components.code, {
            children: "check-types"
          }), " tasks in this guide but you can replace these with other tasks that interest you, like ", _jsx(_components.code, {
            children: "lint"
          }), " or ", _jsx(_components.code, {
            children: "test"
          }), "."]
        }), _jsxs(Tabs, {
          items: ['Next.js', 'Vite'],
          storageKey: "framework-preference",
          children: [_jsxs(Tab, {
            value: "Next.js",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"$schema\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"https://turborepo.com/schema.json\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"tasks\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\".next/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"!.next/cache/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["For more information on configuring your ", _jsx(_components.code, {
                children: "turbo.json"
              }), ", see the ", _jsx(_components.a, {
                href: "/docs/reference/configuration",
                children: "Configuration Options"
              }), " documentation."]
            }), _jsxs(_components.p, {
              children: ["In your Next.js application, make sure you have a ", _jsx(_components.code, {
                children: "check-types"
              }), " script for ", _jsx(_components.code, {
                children: "turbo"
              }), " to run."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"scripts\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"check-types\": \"tsc --noEmit\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          }), _jsxs(Tab, {
            value: "Vite",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"$schema\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"https://turborepo.com/schema.json\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"tasks\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"outputs\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"dist/**\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"dependsOn\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"^check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "]"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"persistent\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " true"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"cache\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " false"
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["Some Vite starters ship with a ", _jsx(_components.code, {
                children: "package.json"
              }), " that looks like this:"]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc && vite build\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsxs(_components.p, {
              children: ["We recommend splitting these into a ", _jsx(_components.code, {
                children: "check-types"
              }), " and ", _jsx(_components.code, {
                children: "build"
              }), " script so that ", _jsx(_components.code, {
                children: "turbo"
              }), " can run them in parallel."]
            }), _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"vite build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"check-types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --noEmit\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["In a multi-package workspace, you may also want to add a ", _jsx(_components.code, {
            children: "check-types"
          }), " script\nto one or more of your library packages to see how multiple scripts across\ndifferent packages run with one ", _jsx(_components.code, {
            children: "turbo"
          }), " command."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "edit-gitignore",
          children: ["Edit ", _jsx(_components.code, {
            children: ".gitignore"
          })]
        }), _jsxs(_components.p, {
          children: ["Add ", _jsx(_components.code, {
            children: ".turbo"
          }), " to your ", _jsx(_components.code, {
            children: ".gitignore"
          }), " file. The ", _jsx(_components.code, {
            children: "turbo"
          }), " CLI uses these folders for persisting logs, outputs, and other functionality."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: ".gitignore",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ .turbo"
                })
              })
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "add-a-packagemanager-field-to-root-packagejson",
          children: ["Add a ", _jsx(_components.code, {
            children: "packageManager"
          }), " field to root ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), _jsxs(_components.p, {
          children: ["Turborepo optimizes your repository using information from your package manager. To declare which package manager you're using, add a ", _jsx(_components.a, {
            href: "https://nodejs.org/api/packages.html#packagemanager",
            children: _jsx(_components.code, {
              children: "packageManager"
            })
          }), " field to your root ", _jsx(_components.code, {
            children: "package.json"
          }), " if you don't have one already."]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"pnpm@10.0.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"yarn@1.22.19\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"npm@8.5.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun (Beta)",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+  \"packageManager\": \"bun@1.2.0\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          })]
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsxs(_components.p, {
            children: ["Depending on your repository, you may need to use the\n", _jsx(_components.a, {
              href: "/docs/reference/configuration#dangerouslydisablepackagemanagercheck",
              children: _jsx(_components.code, {
                children: "dangerouslyDisablePackageManagerCheck"
              })
            }), "\nwhile migrating or in situations where you can't use the ", _jsx(_components.code, {
              children: "packageManager"
            }), " key\nyet."]
          })
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "set-up-package-manager-workspaces",
          children: "Set up package manager workspaces"
        }), _jsxs(_components.p, {
          children: ["For ", _jsx(_components.a, {
            href: "https://vercel.com/docs/glossary#multi-package-workspace",
            children: "multi-package workspaces"
          }), ", you'll need to configure your package manager to recognize your workspace structure."]
        }), _jsxs(_components.p, {
          children: ["The ", _jsx(_components.code, {
            children: "workspaces"
          }), " field tells your package manager which directories contain your packages. Common patterns include ", _jsx(_components.code, {
            children: "apps/*"
          }), " for applications and ", _jsx(_components.code, {
            children: "packages/*"
          }), " for shared libraries."]
        }), _jsx(Callout, {
          type: "good-to-know",
          children: _jsx(_components.p, {
            children: "If you're working with a single-package repository, you can skip this step as\nworkspaces aren't needed."
          })
        }), _jsxs(PackageManagerTabs, {
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "pnpm-workspace.yaml",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "packages:"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"apps/*\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"packages/*\""
                    })]
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://pnpm.io/pnpm-workspace_yaml",
              children: "pnpm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "yarn",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://yarnpkg.com/features/workspaces#how-are-workspaces-declared",
              children: "yarn workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "npm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://docs.npmjs.com/cli/v7/using-npm/workspaces#defining-workspaces",
              children: "npm workspace documentation"
            })]
          }), _jsxs(Tab, {
            value: "bun (Beta)",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://bun.sh/docs/install/workspaces",
              children: "bun workspace documentation"
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["For more details on how to structure your repository, see ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#declaring-directories-for-packages",
            children: "Structuring a Repository"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "run-tasks-with-turbo",
          children: ["Run tasks with ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["You can now run the tasks you added to ", _jsx(_components.code, {
            children: "turbo.json"
          }), " earlier using Turborepo. Using the example tasks from above:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " check-types"
                })]
              })
            })
          })
        }), _jsxs(_components.p, {
          children: ["This runs the ", _jsx(_components.code, {
            children: "build"
          }), " and ", _jsx(_components.code, {
            children: "check-types"
          }), " tasks at the same time. The dependency graph of your ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-workspace",
            children: "Workspace"
          }), " will be used to run tasks in the right order."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.p, {
          children: _jsxs(_components.strong, {
            children: ["Without making any changes to the code, try running ", _jsx(_components.code, {
              children: "build"
            }), " and ", _jsx(_components.code, {
              children: "check-types"
            }), " again:"]
          })
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " check-types"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: "You should see terminal output like this:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Tasks:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "    2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " successful,"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " 2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " total"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Cached:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "    2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " cached,"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " 2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " total"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "Time:"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: "    185ms"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " >>> "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: "FULL"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " TURBO"
                })]
              })]
            })
          })
        }), _jsxs(_components.p, {
          children: ["Congratulations! ", _jsx(_components.strong, {
            children: "You just built and type checked your code in milliseconds"
          }), "."]
        }), _jsxs(_components.p, {
          children: ["To learn more about how ", _jsx(_components.code, {
            children: "turbo"
          }), " makes this possible, check out ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/caching",
            children: "the caching documentation"
          }), "."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "begin-developing-by-running-dev-with-turbo",
          children: ["Begin developing by running ", _jsx(_components.code, {
            children: "dev"
          }), " with ", _jsx(_components.code, {
            children: "turbo"
          })]
        }), _jsxs(_components.p, {
          children: ["In a multi-package workspace, you can run ", _jsx(_components.code, {
            children: "turbo dev"
          }), " to start the development tasks for all your packages at once."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        }), _jsxs(_components.p, {
          children: ["You can also ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/running-tasks#using-filters",
            children: "use a filter"
          }), " to focus on a specific package and its dependencies."]
        }), _jsxs(Callout, {
          type: "info",
          children: [_jsx(_components.p, {
            children: "Note that this step doesn't provide much value in a single-package workspace since:"
          }), _jsxs(_components.ul, {
            children: ["\n", _jsx(_components.li, {
              children: "You don't cache the outputs for a development task."
            }), "\n", _jsx(_components.li, {
              children: "There's only one development script so there's nothing to run in parallel."
            }), "\n"]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h2, {
          id: "next-steps",
          children: "Next steps"
        }), _jsxs(_components.p, {
          children: ["You're now up and running with Turborepo! To learn about more ways you can improve your workflow and get the most out of ", _jsx(_components.code, {
            children: "turbo"
          }), ", we recommend checking out the following pages:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "/docs/crafting-your-repository/constructing-ci#enabling-remote-caching",
              children: "Enabling Remote Caching for development machines"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "/docs/crafting-your-repository/constructing-ci",
              children: "Enabling Remote Caching in CI"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "/docs/crafting-your-repository/using-environment-variables",
              children: "Handling environment variables"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--filter-string",
              children: "Filtering tasks"
            })
          }), "\n"]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
